/* eslint-disable react/display-name */
import React, { useState, useEffect } from "react";
import { Collapse, Modal, Spin } from "antd";
import Helpers from "../../services/helpers";
import Services from "../../services";
import Toaster from "../../services/toaster";
import { generateCardTitle } from "../../utils/cardList";
import { useSearchContext } from "../contexts/searchcontext.ts";

import { usePopularChartContext } from "../contexts/popularchartcontext";
import PopularResultPanel from "../charts/PopularCardChart/PopularResultPanel";
import { ENTITY_TYPES } from "utils/constants";

const { Panel } = Collapse;

const getPanelHeaderText = ({ entity, entityType, last_update, count, type, isLoading, stats }) => {
  const entityStats = stats[entity.id];

  const name = {
    CARD: generateCardTitle(entity),
    SEALED_WAX: Helpers.getSealedWaxName(entity),
  }[entityType];

  const renderTip = () => {
    const typeName = entityType === "SEALED_WAX" ? "Wax" : "Card";

    if (entityStats.endCount) {
      return `Average Last Sale Of This ${typeName}: `;
    }
    return `Average of Last ${entityStats.endCount} Sales Of This ${typeName}: `;
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
      {isLoading || !entityStats ? (
        <>
          <span>{name}</span>
          <Spin />
        </>
      ) : (
        <>
          <span>
            {`${name}, Active eBay ${type === "auction" ? "Auctions" : "Buy It Now"} - ${
              count > 0 ? count + " Results" : "No Results"
            } - Last Synced ${Helpers.formatDateWithTime(last_update, true)} EST`}{" "}
          </span>
          <span>
            {renderTip()}
            {Helpers.formatMoney(entityStats.endAvg)}
          </span>
        </>
      )}
    </div>
  );
};

export function entityImageModal(image) {
  Modal.info({
    content: (
      <div>
        <img src={image} width={"100%"} />
      </div>
    ),
    icon: null,
    maskClosable: true,
    onOk() {},
  });
}

export const setFileImage = async (card_id, auction_id) => {
  try {
    await Services.setCardImage(card_id, auction_id);
    Toaster.SuccessNotification("Card has been updated.", "");
  } catch (e) {
    Toaster.ErrorNotification("Error occurred setting image", e.message);
  }
};

export const toggleAuctionInclusion = async (card_active_result_id, value, refresh) => {
  try {
    const updatedResult = await Services.updateActiveInclusion(card_active_result_id, value);

    if (updatedResult.error) {
      Toaster.ErrorNotification("Error occurred removing auction", updatedResult.error.message);
    } else {
      // TODO: Find a faster way to update ths page when a card is removed.
      // removed so Geoff can get through the deletions quicker.
      if (refresh) {
        await refresh();
      }
      Toaster.SuccessNotification("Auction has been updated.", "");
    }
  } catch (ex) {
    Toaster.ErrorNotification("Error occurred removing auction", ex.message);
  }
};

const ActiveResultsList = ({ type, entityType, activeResults, isLoading, getActiveAuctions, onPaginationChange }) => {
  const { cards, sealedWaxes, hiddenLines } = usePopularChartContext();
  const { popularCardStats, popularSealedWaxStats } = useSearchContext();
  const [visiblePanes, setVisiblePanes] = useState([]);

  const [entities, stats] = {
    [ENTITY_TYPES.CARD]: [cards, popularCardStats],
    [ENTITY_TYPES.SEALED_WAX]: [sealedWaxes, popularSealedWaxStats],
  }[entityType];

  const refreshEntities = () => {
    getActiveAuctions(entities);
  };

  const onChange = (value) => {
    setVisiblePanes(value);
  };

  useEffect(() => {
    if (isLoading) {
      setVisiblePanes([]);
      return;
    }

    const visibleIds = entities
      .map((entity) => entity.id)
      .filter((entityId) => {
        return !hiddenLines[entityId];
      });

    setVisiblePanes(visibleIds);
  }, [isLoading, activeResults]);

  return (
    <>
      {cards.length > 0 && (
        <h2 style={{ margin: "30px 0" }}>Active eBay {type === "auction" ? " Auctions (Ad) " : " Buy It Now (Ad) "}</h2>
      )}
      <Collapse defaultActiveKey={[]} activeKey={visiblePanes} onChange={onChange}>
        {entities.map((entity) => (
          <Panel
            key={entity.id}
            header={getPanelHeaderText({
              entity,
              entityType,
              last_update: entity.last_live_synced_at,
              count: activeResults[entity.id] ? activeResults[entity.id].total : 0,
              type,
              isLoading,
              stats,
            })}
          >
            <PopularResultPanel
              key={entity.id}
              entity={entity}
              entityType={entityType}
              statsForCard={stats[entity.id]}
              onPaginationChange={onPaginationChange}
              results={activeResults[entity.id] ? activeResults[entity.id].data : []}
              totalCount={activeResults[entity.id] ? activeResults[entity.id].total : 0}
              type={type}
              refresh={refreshEntities}
            />
          </Panel>
        ))}
      </Collapse>
    </>
  );
};

export default ActiveResultsList;
